module.exports = __webpack_public_path__ + "static/img/home-pay.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-pay.png
// module id = 536
// module chunks = 0